import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import {
  EStaticCategory,
  GiftcardCategoryService,
} from 'src/app/shared-data/giftcard-category.service';
import { ETagProduct, ETagType, GiftCard } from '~models';
import { GiftCardsService, TrxService } from '~services';

@Component({
  selector: 'app-gift-card-category',
  templateUrl: './gift-card-category.component.html',
  styleUrls: ['./gift-card-category.component.scss'],
})
export class GiftCardCategoryComponent implements OnInit {
  @ViewChild('listCategoriesBox', { static: true }) listCategoriesBoxRef: ElementRef;

  shouldShowZipMoneyOnlyDealsCategory = false;
  shouldShowOtherDealsCategory = false;
  staticCategory = EStaticCategory;

  private allGiftCards: GiftCard[] = [];

  constructor(
    public giftcardCategoryService: GiftcardCategoryService,
    public giftCardService: GiftCardsService,
    private trxService: TrxService,
  ) {}

  async ngOnInit() {
    this.giftcardCategoryService.setCategoryBoxRef(this.listCategoriesBoxRef);
    const giftCards = await this.giftCardService.getCards();
    this.allGiftCards = [...giftCards];
    this.shouldShowZipMoneyOnlyDealsCategory = this.getShouldShowZipMoneyOnlyDealsCategory();
    this.shouldShowOtherDealsCategory = this.getShouldShowOtherDealsCategory();
  }

  public toggleActive(categoryId: EStaticCategory) {
    this.giftcardCategoryService.setSelectedCategoryId(categoryId);
    this.giftCardService.getCardCategoryById(categoryId);
    this.giftcardCategoryService.setSearchGiftCardsInput('');
    this.trxService.sendUIClickEvent({
      action_type: 'click',
      control_type: 'button',
      label: `Category: ${categoryId}`,
      control_id: null,
      destination_target_url: null,
    });
  }

  private getShouldShowZipMoneyOnlyDealsCategory() {
    return this.allGiftCards.some((g) =>
      g.tags?.some(
        (t) =>
          t.type === ETagType.CASHBACK &&
          t.products?.length === 1 &&
          t.products[0] === ETagProduct.ZM,
      ),
    );
  }

  private getShouldShowOtherDealsCategory() {
    return this.allGiftCards.some((g) =>
      g.tags?.some(
        (t) =>
          t.products?.length > 1 || (t.products?.length === 1 && t.products[0] !== ETagProduct.ZM),
      ),
    );
  }
}
